import { AssetIdSchema as C, CreativeGroupIdSchema as R } from "@hprofits/shared";
import { PrivilegeEnum as e } from "@hprofits/shared/auth";
import { z as o } from "zod";
import "../common/acl-view.js";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as c } from "../common/creation-result.js";
import "../common/owner.js";
import { CampaignGroupIdParamSchema as d, CreativeGroupIdParamSchema as i, LandingGroupIdParamSchema as g, LandingIdParamSchema as v, CreativeIdParamSchema as h, ForceActionParamSchema as S, AssetIdParamSchema as p } from "../common/params.js";
import "../common/errors/constants.js";
import { inUseError as s, notFoundError as r, alreadyExistsError as n, expectationFailedError as u } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as a } from "../swagger/tags.js";
import { CreateCreativeGroupCommonSchema as G, CreateCreativeGroupAdminSchema as I, UpdateCreativeGroupCommonSchema as A, UpdateCreativeGroupAdminSchema as f, LandingGroupUpdateBaseSchema as T, validateLandingGroupRates as y, LandingGroupListItemSchema as l, LandingGroupCreateSchema as P, LandingGroupListQuerySchema as w, LandingGroupListSchema as U, LandingUpdateSchema as L, LandingListItemSchema as E, LandingCreateSchema as O, LandingListQuerySchema as V, LandingListSchema as _, CreativeUpdateSchema as W, CreativeListItemSchema as m, CreativeCustomContentCreateSchema as x, CreativeCreateSchema as b, CreativeListQuerySchema as D, CreativeListSchema as j, CreativeRejectReasonsDictionarySchema as z, CreativeReviewSchema as F, LandingRejectReasonsDictionarySchema as Q, LandingReviewSchema as q, UpdateAssetSchema as H, AssetViewSchema as M, CreateAssetSchema as k, RenameCreativeGroupSchema as B, CreativeGroupViewSchema as J, CreativeGroupListSchema as K } from "./schemas.js";
const N = o.union([
  G.unwrap().extend({
    campaignId: d.shape.campaignId
  }),
  I.unwrap().extend({
    campaignId: d.shape.campaignId
  })
]), X = o.union([
  A.unwrap().extend({
    creativeGroupId: i.shape.creativeGroupId
  }),
  f.unwrap().extend({
    creativeGroupId: i.shape.creativeGroupId
  })
]), me = {
  creativeGroup: {
    /**
     * Get all creative groups for a campaign
     */
    findAll: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns/{campaignId}/creative-groups",
      summary: "Get all creative groups for a campaign",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(d).output(K).errors({
      ...r("Campaign not found")
    }),
    /**
     * Create a new creative group for a campaign
     */
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns/{campaignId}/creative-groups",
      summary: "Create a creative group for a campaign",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(N).output(c(R)).errors({
      ...r("Ad type or format not found"),
      ...u("Referenced type/format entity in body not found or mismatched"),
      ...n("Creative group with this name already exists")
    }),
    /**
     * Get a creative group by ID
     */
    findOne: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Get a creative group by ID",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(i).output(J).errors({
      ...r("Creative group not found")
    }),
    /**
     * Update a creative group
     */
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Update a creative group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(X).output(o.void()).errors({
      ...r("Creative group or referenced type/format not found"),
      ...u("Referenced type/format entity in body not found or mismatched")
    }),
    /**
     * Rename a creative group
     */
    rename: t([e.WriteAdvert]).route({
      method: "PATCH",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Rename a creative group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(
      B.unwrap().extend({
        creativeGroupId: i.shape.creativeGroupId
      })
    ).output(o.void()).errors({
      ...r("Creative group not found"),
      ...n("Creative group with this name already exists")
    }),
    /**
     * Delete a creative group
     */
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Delete a creative group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(i).output(o.void()).errors({
      ...r("Creative group not found"),
      ...s("Creative group is used in ad groups")
    })
  },
  asset: {
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns/{campaignId}/creative-groups/{creativeGroupId}/assets",
      summary: "Add an asset into a creative group.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(
      k.unwrap().extend({
        campaignId: d.shape.campaignId,
        creativeGroupId: i.shape.creativeGroupId
      })
    ).output(c(C)).errors({
      ...r("Landing or creative not found"),
      ...n("Duplicate asset")
    }),
    read: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/assets/{assetId}",
      summary: "Read an asset.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(p).output(M).errors({
      ...r("Asset not found")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/assets/{assetId}",
      summary: "Modify an asset.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204,
      inputStructure: "detailed"
    }).input(
      o.object({
        params: p,
        query: S,
        body: H
      })
    ).output(o.void()).errors({
      ...r("Landing or creative not found"),
      ...n("Duplicate asset"),
      ...s("Asset is in use and cannot be modified")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/assets/{assetId}",
      summary: "Remove an asset from a creative group.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204,
      inputStructure: "detailed"
    }).input(
      o.object({
        params: p,
        query: S
      })
    ).output(o.void()).errors({
      ...r("Asset not found"),
      ...s("Asset is in use and cannot be deleted")
    })
  },
  review: {
    landings: {
      review: t([e.WriteAdmin]).route({
        method: "POST",
        path: "/review/landings",
        summary: "Implement landings review process.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 204
      }).input(q.unwrap()).output(o.void()).errors({}),
      rejectReasons: t([e.WriteAdmin]).route({
        method: "GET",
        path: "/review/landings/dictionary/reject-reasons",
        summary: "Return recognizable reject reasons for landings.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 200
      }).output(Q).errors({})
    },
    creatives: {
      review: t([e.WriteAdmin]).route({
        method: "POST",
        path: "/review/creatives",
        summary: "Implement creatives review process.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 204
      }).input(F.unwrap()).output(o.void()).errors({}),
      rejectReasons: t([e.WriteAdmin]).route({
        method: "GET",
        path: "/review/creatives/dictionary/reject-reasons",
        summary: "Return recognizable reject reasons for creatives.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 200
      }).output(z).errors({})
    }
  },
  creatives: {
    list: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/creatives",
      summary: "Get all creatives available for a user",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(D).output(j).errors({}),
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/creatives",
      summary: "Upload a creative file (multipart form data) for the caller or, by an admin, for another owner",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(b.unwrap()).output(m).errors({
      ...r("Owner, ad type or ad tag not found"),
      ...u("The file is not accepted for the ad type")
    }),
    createCustomContent: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/creatives/custom-content",
      summary: "Create a creative that carries HTML, VAST or an address instead of a file",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(x.unwrap()).output(m).errors({
      ...r("Owner, ad tag or banner size not found"),
      ...u("The ad type takes no creative")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/creatives/{creativeId}",
      summary: "Update the texts, ad tags and custom content of a creative",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(W.unwrap().extend(h.shape)).output(m).errors({
      ...r("Creative or ad tag not found"),
      ...u("The texts or the content are not accepted for the creative")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/creatives/{creativeId}",
      summary: "Delete a creative that no creative group or campaign uses",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(h).output(o.void()).errors({
      ...r("Creative not found"),
      ...s("Creative is used in creative groups or campaigns")
    })
  },
  landings: {
    list: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/landings",
      summary: "Get all landings available for a user",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(V).output(_).errors({}),
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/landings",
      summary: "Create a landing in a new landing group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(O.unwrap()).output(E).errors({
      ...r("Owner or ad tag not found"),
      ...n("Landing group with this name already exists for the owner")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/landings/{landingId}",
      summary: "Update the url and ad tags of a landing",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(L.unwrap().extend(v.shape)).output(E).errors({
      ...r("Landing or ad tag not found")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/landings/{landingId}",
      summary: "Delete a landing, and its group when it was the last landing there",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(v).output(o.void()).errors({
      ...r("Landing not found"),
      ...s("Landing group is used in creative groups or campaigns")
    })
  },
  landingGroups: {
    list: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/landing-groups",
      summary: "Get all landing groups available for a user, with their landings",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(w).output(U).errors({}),
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/landing-groups",
      summary: "Create a landing group with one or more landings",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(P.unwrap()).output(l).errors({
      ...r("Owner or ad tag not found"),
      ...n("Landing group with this name already exists for the owner")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/landing-groups/{landingGroupId}",
      summary: "Replace the name, algorithm and landings of a landing group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(
      T.extend(g.shape).superRefine(y)
    ).output(l).errors({
      ...r("Landing group, landing or ad tag not found"),
      ...n("Landing group with this name already exists for the owner")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/landing-groups/{landingGroupId}",
      summary: "Delete a landing group and its landings",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(g).output(o.void()).errors({
      ...r("Landing group not found"),
      ...s("Landing group is used in creative groups or campaigns")
    })
  }
};
export {
  me as creativeGroupContract
};
//# sourceMappingURL=contract.js.map
